import { ModalController } from "./Controller/ModalController.js";
import { AlertModalController } from "./Controller/AlertModalController.js";
import { ConfirmModalController } from "./Controller/ConfirmModalController.js";
import { LoadingModalController } from "./Controller/LoadingModalController";
import { RegisterSuccessModalController } from "./Controller/RegisterSuccessModalController.js";
import { TermsModalController } from './Controller/TermsModalController'

export default function ModalFactory() {
    this.modalController = new ModalController();
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;

    this.getModalController = function() {
        return this.modalController;
    };

    this.getAlertModal = function() {
        this.alertModal = new AlertModalController();
        this.modalController.setAlertModal(this.alertModal);
        return this.alertModal;
    };

    this.getConfirmModal = function() {
        this.confirmModal = new ConfirmModalController();
        this.modalController.setConfirmModal(this.confirmModal);
        return this.confirmModal;
    };

    this.getLoadingModal = function() {
        this.loadingModal = new LoadingModalController();
        this.modalController.setLoadingModal(this.loadingModal);
        return this.loadingModal;
    };

    this.getRegisterSuccessModal = function() {
        this.registerSuccessModal = new RegisterSuccessModalController();
        this.modalController.setRegisterSuccessModal(this.registerSuccessModal);
        return this.registerSuccessModal;
    };

    this.getTermsModal = function() {
        this.termsModal = new TermsModalController();
        this.modalController.setTermsModal(this.termsModal);
        return this.termsModal;
    };
}
